import { useApi } from '@gravitate-js/the-armory'
import { useMutation, useQuery } from '@tanstack/react-query'
import { getAPIURL } from '@utils/api'
import { setIdsOnRows } from '../utils.js'

export const useTrailers = () => {
  const api = useApi({ baseURLOverride: getAPIURL() })

  const useGetTrailerConfigQuery = (filter = {}) =>
    useQuery({
      queryKey: ['getTrailerConfigQuery', filter],
      queryFn: () => setIdsOnRows(api, 'trailer/trailer_config/overview', { filter }, false),
    })

  const updateTrailerMutation = () =>
    useMutation({
      mutationKey: ['updateTrailer'],
      mutationFn: (trailer: Trailer) => {
        if (trailer?.trailer_number) trailer.trailer_number = trailer.trailer_number.toString()
        return api.post('trailer/update', trailer)
      },
    })

  return { useGetTrailerConfigQuery, updateTrailerMutation }
}

interface Trailer {
  extra_data: {}
  updated_on: Date
  updated_by: string
  trailer_number: number | string
  configuration: string
  depot: string
  make: string
  model: string
  weight: number
  id: string
  key: string
}
